<div class="content print-fullscreen">
	<div class="top-row-with-sidebar mb-2 flexrow print-hide">
		<app-splitbutton [elements]="[backSplitButton]"></app-splitbutton>
		<app-select-exports-button *ngIf="exportsViewModel$ | async as model"
								[listOfSelectedParticipants]="model.selectedParticipant"
								[exportConfigs]="model.exportConfigs"
								[reportConfigsinMenu]="model.menuReportConfigs"
								(reportConfigToPrint)="reportFilter$.next($event)"
								sourceWindow="participantDetails">
		</app-select-exports-button>
	</div>
	<app-form-schema-renderer *ngIf="formModel$ | async as model" [property]="[]" [schema]="model.schema" [data]="model.data" [readonly]="true"
							class="print-hide">
	</app-form-schema-renderer>
	<div *ngIf="report$ | async as report">
		<workflow-report-card [participant]="report.participant" [usedReportConfigs]="report.configs" [reportData]="report.data">
		</workflow-report-card>
	</div>
	<div *appIfPermission="'protocol:read'" class="print-hide">
		<app-participant-timeline></app-participant-timeline>
	</div>
</div>
<workflow-projektsidebar class="sidebar" *ngIf="participant$ | async as participant" [currentParticipant]="participant">
</workflow-projektsidebar>
